module.exports = __webpack_public_path__ + "img/bozidar_novak.58eab4f9.jpg";